import {SvgIcon} from '@mui/material';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {MemberOperationType, openModal, UserSquare, LogOut01} from 'palipali-panel-common-web';

export const useSubMenuSections = () => {
    const {t} = useTranslation(),
        dispatch = useDispatch();

    return useMemo(() => {
        return [
            {
                items: [
                    {
                        title: t('menuItems.account'),
                        path: '/panel/account',
                        icon: (
                            <SvgIcon fontSize="large">
                                <UserSquare />
                            </SvgIcon>
                        ),
                        class: 'account-menu-item',
                    },
                    {
                        title: t('menuItems.logout'),
                        icon: (
                            <SvgIcon fontSize="large">
                                <LogOut01 />
                            </SvgIcon>
                        ),
                        onClick: () => {
                            dispatch(openModal(MemberOperationType.LOGOUT));
                        },
                        class: 'logout-menu-item',
                    },
                ],
            },
        ];
    }, [t]);
};
